const GOODDEALS_MIN_PROMO = 5;

export const offerPromotionIsEnoughToBeInGoodDeal = offer => {
    if (offer.promotion === undefined) {
        return false;
    }

    return (
        ((offer.promotion.originalOfferPrice.amount - offer.price.amount) * 100) /
            offer.promotion.originalOfferPrice.amount >=
        GOODDEALS_MIN_PROMO
    );
};
